import { getCenter } from "ol/extent";
import Map from "ol/Map";
import PropTypes from "prop-types";
import { Component } from "react";
import { connect } from "react-redux";

import { Fullextent as FullExtentImg } from "../icons";

import "./FullExtentButton.css";

const propTypes = {
  config: PropTypes.object.isRequired,
  map: PropTypes.instanceOf(Map).isRequired,
  mode: PropTypes.string.isRequired,
};

class FullExtentButton extends Component {
  render() {
    return (
      <div
        className="map-control"
        id="full-extent-button"
        onClick={() => this.zoomToFullExtent()}
        onKeyPress={(e) => e.which === 13 && this.zoomToFullExtent()}
        role="button"
        tabIndex="0"
        title="Auf volle Ausdehnung zoomen"
      >
        <FullExtentImg />
      </div>
    );
  }

  zoomToFullExtent() {
    const { config, map, mode } = this.props;
    const ext = config[mode].extent;
    const resolution = map.getView().getResolutionForExtent(ext);
    const center = getCenter(ext);
    map.getView().animate({ center, resolution });
  }
}

FullExtentButton.propTypes = propTypes;

const mapStateToProps = (state) => ({
  config: state.config,
  map: state.map,
  mode: state.mode,
});

export default connect(mapStateToProps)(FullExtentButton);
